"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNativeWeb = require("react-native-web");

var _AaButton = require("./AaButton.model");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _uiUtils = require("@airasia/ui-utils");

var AaButtonInner = function AaButtonInner(props) {
  var controls = props.controls || null,
      translation = props.translation || null,
      data = props.data || '';
  var title = data && data.text || _AaButton.DEFAULT_BUTTON_TEXT;
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: [defaultStyles.buttonText, controls && controls.customStyle && controls.customStyle.text, controls.disabled && defaultStyles.disabledText]
  }, title);
};

var defaultStyles = _StyleSheet["default"].create({
  buttonText: {
    color: '#fff',
    fontSize: 16,
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB,
      fontWeight: '500'
    }
  },
  disabledText: {
    color: '#fff'
  }
});

var _default = AaButtonInner;
exports["default"] = _default;